var _rect, _rect2, _g, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path2, _path3, _circle2, _g2, _circle3, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path4, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _path5, _path6, _circle4, _rect37, _rect38, _rect39, _path7, _rect40, _rect41, _circle5, _rect42, _rect43, _circle6, _path8, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _path9, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _path10, _path11, _path12, _path13, _path14, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326 249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.539,
    width: 29.395,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 191.645,
    width: 37.541,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.539,
    y: 20.543,
    width: 196.559,
    height: 107.311,
    rx: 2.125,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.716,
    y: 20.72,
    width: 196.205,
    height: 106.957,
    rx: 1.948,
    stroke: "#EDF2F9",
    strokeWidth: 0.354
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 138.517,
    cy: 119.004,
    r: 3.187,
    fill: "#EDF2F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 140.643,
    y: 95.271,
    width: 24.083,
    height: 8.5,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 167.56,
    y: 95.271,
    width: 16.291,
    height: 8.5,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 186.681,
    y: 95.271,
    width: 24.083,
    height: 8.5,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 139.936,
    y: 65.52,
    width: 163.268,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 139.936,
    y: 71.542,
    width: 140.248,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 144.539,
    y: 82.525,
    width: 19.479,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 139.936,
    y: 82.525,
    width: 3.542,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F9",
    d: "M308.871 29.044h1.417v1.417h-1.417zM311.35 29.044h1.417v1.417h-1.417zM313.83 29.044h1.417v1.417h-1.417z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 136.04,
    y: 43.206,
    width: 16.291,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 172.874,
    y: 43.206,
    width: 14.521,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 209.708,
    y: 43.206,
    width: 14.875,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 246.536,
    y: 43.206,
    width: 33.291,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 136.04,
    y: 51.002,
    width: 18.416,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 172.874,
    y: 51.002,
    width: 17.354,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 209.708,
    y: 51.002,
    width: 17.354,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 246.536,
    y: 51.002,
    width: 33.645,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 135.329,
    y: 30.457,
    width: 70.124,
    height: 5.667,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 144.183,
    y: 116.166,
    width: 46.395,
    height: 5.667,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.722 109.967l195.84-.088",
    stroke: "#D8DCE4",
    strokeOpacity: 0.5,
    strokeWidth: 0.354,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M136.04 68.351h169.643v13.104H136.04z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.038,
    cy: 66.939,
    r: 0.708,
    fill: "#EDF2F9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.535,
    y: 139.059,
    width: 196.559,
    height: 107.311,
    rx: 2.125,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.712,
    y: 139.236,
    width: 196.205,
    height: 106.957,
    rx: 1.948,
    stroke: "#EDF2F9",
    strokeWidth: 0.354
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.514,
    cy: 237.52,
    r: 3.187,
    fill: "#EDF2F9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 140.64,
    y: 213.787,
    width: 24.083,
    height: 8.5,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 167.557,
    y: 213.787,
    width: 16.291,
    height: 8.5,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 186.677,
    y: 213.787,
    width: 24.083,
    height: 8.5,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 139.932,
    y: 184.035,
    width: 163.268,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 139.932,
    y: 190.057,
    width: 140.248,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 144.536,
    y: 201.035,
    width: 19.479,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 139.932,
    y: 201.035,
    width: 3.542,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F9",
    d: "M308.868 147.56h1.417v1.417h-1.417zM311.341 147.56h1.417v1.417h-1.417zM313.827 147.56h1.417v1.417h-1.417z"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 136.037,
    y: 161.722,
    width: 16.291,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 172.868,
    y: 161.722,
    width: 14.521,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 209.699,
    y: 161.722,
    width: 14.875,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 246.533,
    y: 161.722,
    width: 33.291,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 136.037,
    y: 169.518,
    width: 18.416,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 172.868,
    y: 169.518,
    width: 17.354,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 209.699,
    y: 169.518,
    width: 17.354,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 246.533,
    y: 169.518,
    width: 33.645,
    height: 3.187,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 135.326,
    y: 148.973,
    width: 70.124,
    height: 5.667,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 144.18,
    y: 234.682,
    width: 46.395,
    height: 5.667,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.719 228.483l195.84-.089",
    stroke: "#D8DCE4",
    strokeOpacity: 0.5,
    strokeWidth: 0.354,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M136.037 186.867H305.68v13.104H136.037z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.035,
    cy: 185.455,
    r: 0.708,
    fill: "#EDF2F9"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 165.438,
    width: 17.708,
    height: 4.25,
    rx: 1.062,
    fill: "#EDF2F9"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 114.309,
    height: 230.522,
    rx: 2.54,
    transform: "matrix(-1 0 0 1 114.309 0)",
    fill: "#F7F9FC"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 11.747,
    y: 16.512,
    width: 53.344,
    height: 3.175,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.407 95.446h1.308c.74 0 1.104-.377 1.104-.88 0-.49-.348-.778-.692-.795v-.031c.316-.075.565-.296.565-.689 0-.481-.347-.838-1.048-.838H5.407v3.233zm.585-.49v-.947h.646c.361 0 .586.221.586.51 0 .258-.177.438-.602.438h-.63zm0-1.368v-.892h.592c.344 0 .523.181.523.431 0 .284-.23.46-.535.46h-.58zm2.31 1.858h.572V93.02h-.571v2.425zm.288-2.769c.182 0 .33-.139.33-.31 0-.171-.148-.31-.33-.31-.183 0-.331.139-.331.31 0 .171.148.31.331.31zm1.93 2.816c.71 0 1.162-.5 1.162-1.25 0-.751-.452-1.253-1.162-1.253s-1.162.502-1.162 1.253c0 .75.451 1.25 1.162 1.25zm.003-.457c-.393 0-.586-.351-.586-.794 0-.444.193-.8.586-.8.387 0 .58.356.58.8 0 .443-.193.793-.58.793z",
    fill: "#0B0826"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 2.544,
    y: 33.664,
    width: 109.228,
    height: 43.501,
    rx: 2.54,
    fill: "#F0F4F9"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 91.452,
    y: 41.284,
    width: 12.701,
    height: 6.35,
    rx: 3.175,
    fill: "#E4EBF5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.979,
    cy: 44.459,
    r: 2.54,
    fill: "#fff"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 101.612,
    y: 205.757,
    width: 7.621,
    height: 7.621,
    rx: 1.27,
    fill: "#E7EBF1"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 101.612,
    y: 215.916,
    width: 7.621,
    height: 7.621,
    rx: 1.27,
    fill: "#E7EBF1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.534,
    cy: 11.432,
    r: 6.35,
    fill: "#EDF2F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF2F9",
    d: "M105.099 8.569h3.175v2.54h-3.175z"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 5.082,
    y: 6.669,
    width: 62.87,
    height: 5.08,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 5.082,
    y: 135.902,
    width: 25.719,
    height: 3.81,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 92.396,
    width: 9.843,
    height: 3.81,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 79.7,
    y: 68.271,
    width: 24.449,
    height: 3.81,
    rx: 0.953,
    fill: "#E4EBF5"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 207.976,
    width: 38.738,
    height: 3.81,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 218.138,
    width: 37.468,
    height: 3.81,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C20010",
    d: "M5.088 16.512h3.81v3.175h-3.81z"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 7.619,
    y: 41.278,
    width: 62.235,
    height: 5.08,
    rx: 0.953,
    fill: "#E4EBF5"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 7.619,
    y: 52.709,
    width: 76.523,
    height: 2.54,
    rx: 0.953,
    fill: "#E4EBF5"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 7.619,
    y: 60.015,
    width: 50.169,
    height: 2.54,
    rx: 0.953,
    fill: "#E4EBF5"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 143.52,
    width: 19.686,
    height: 2.858,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 160.986,
    width: 19.686,
    height: 2.858,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 103.514,
    width: 96.21,
    height: 2.858,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 109.861,
    width: 83.191,
    height: 2.858,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 115.896,
    width: 93.352,
    height: 2.858,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 178.448,
    width: 19.686,
    height: 2.858,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 149.555,
    width: 21.592,
    height: 7.621,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 167.017,
    width: 21.592,
    height: 7.621,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 5.088,
    y: 184.482,
    width: 21.592,
    height: 7.621,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 29.209,
    y: 149.555,
    width: 14.606,
    height: 7.621,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 29.209,
    y: 167.017,
    width: 14.606,
    height: 7.621,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 29.209,
    y: 184.482,
    width: 14.606,
    height: 7.621,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 46.359,
    y: 149.555,
    width: 21.592,
    height: 7.621,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 46.359,
    y: 184.482,
    width: 21.592,
    height: 7.621,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 70.49,
    y: 149.555,
    width: 10.796,
    height: 7.621,
    rx: 0.953,
    fill: "#EDF2F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.074 243.139H5.73v-5.655a5.655 5.655 0 0 0-5.655 5.655z",
    fill: "#614FE7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.729 239.605v3.534h3.534a3.534 3.534 0 0 0-3.534-3.534z",
    fill: "#8E82EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.383 243.139H5.73v5.654a5.654 5.654 0 0 0 5.654-5.654z",
    fill: "#614FE7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73 248.793v-5.654H.073a5.654 5.654 0 0 0 5.655 5.654z",
    fill: "#4D3BD8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.924 244.074c.23.222.507.333.84.333.341 0 .628-.111.858-.333.24-.221.36-.489.36-.812 0-.323-.12-.6-.36-.822a1.16 1.16 0 0 0-.858-.341c-.333 0-.61.11-.84.341-.231.222-.342.499-.342.822 0 .323.11.591.342.812zm-1.063-2.521c.444-.471.998-.702 1.653-.702.702 0 1.247.286 1.385.693v-.61h1.376v3.878c0 1.081-.175 1.782-.813 2.272-.452.36-1.015.535-1.69.535-.904 0-1.661-.221-2.28-.655l.656-.998c.47.296.942.444 1.43.444.398 0 .721-.083.952-.24.268-.185.406-.527.406-1.016v-.102c-.194.333-.748.564-1.422.564-.655 0-1.21-.222-1.652-.674-.434-.453-.656-1.016-.656-1.681 0-.674.222-1.246.655-1.708zM23.3 242.729c0-.434-.452-.776-1.006-.776-.6 0-1.09.342-1.127.776H23.3zm-3.527.525c0-.73.24-1.321.71-1.764.472-.452 1.081-.674 1.81-.674.712 0 1.284.231 1.727.683.443.453.665 1.007.665 1.681 0 .157-.01.304-.018.443h-3.518c.027.554.508.914 1.237.914a1.6 1.6 0 0 0 1.136-.452l.803.766a2.694 2.694 0 0 1-2.004.849c-.766 0-1.376-.221-1.846-.655-.471-.443-.702-1.025-.702-1.755v-.036zM25.174 245.592v-4.653h1.375v.581c.176-.406.647-.683 1.21-.683.628 0 1.052.249 1.265.739.258-.49.775-.739 1.551-.739 1.062 0 1.653.72 1.653 1.93v2.825h-1.376v-2.659c0-.545-.25-.877-.692-.877-.453 0-.776.378-.776.923v2.613h-1.376v-2.659c0-.545-.25-.877-.692-.877-.444 0-.767.378-.767.923v2.613h-1.375zM34.438 244.136c.23.231.517.351.858.351.342 0 .628-.12.859-.351.23-.24.35-.527.35-.868 0-.342-.12-.628-.35-.859-.23-.24-.517-.36-.859-.36-.341 0-.628.12-.858.36a1.17 1.17 0 0 0-.351.859c0 .341.12.637.35.868zm2.686-2.614a2.28 2.28 0 0 1 .757 1.745c0 .692-.249 1.274-.757 1.754a2.598 2.598 0 0 1-1.828.711c-.72 0-1.33-.24-1.837-.711a2.339 2.339 0 0 1-.748-1.754c0-.693.249-1.274.748-1.745.507-.48 1.117-.72 1.837-.72.711 0 1.32.24 1.828.72zM39.92 244.074c.23.222.508.333.84.333.342 0 .628-.111.859-.333.24-.221.36-.489.36-.812 0-.323-.12-.6-.36-.822a1.161 1.161 0 0 0-.859-.341c-.332 0-.61.11-.84.341-.231.222-.342.499-.342.822 0 .323.111.591.342.812zm-1.062-2.521c.443-.471.997-.702 1.653-.702.701 0 1.246.286 1.384.693v-.61h1.376v3.878c0 1.081-.175 1.782-.812 2.272-.453.36-1.016.535-1.69.535-.905 0-1.662-.221-2.28-.655l.655-.998c.47.296.942.444 1.431.444.397 0 .72-.083.951-.24.268-.185.406-.527.406-1.016v-.102c-.193.333-.747.564-1.422.564-.655 0-1.209-.222-1.652-.674-.434-.453-.656-1.016-.656-1.681 0-.674.222-1.246.656-1.708zM43.972 245.592v-4.653h1.376v.637c.212-.471.71-.739 1.348-.739.092 0 .212.009.36.028v1.292a2.425 2.425 0 0 0-.462-.046c-.784 0-1.246.444-1.246 1.21v2.271h-1.376zM50.54 244.093c.24-.231.36-.508.36-.831 0-.323-.12-.6-.36-.822a1.16 1.16 0 0 0-.86-.341c-.332 0-.609.11-.84.341-.23.222-.341.499-.341.822 0 .323.11.6.341.831.231.222.508.332.84.332.342 0 .628-.11.86-.332zm.276-2.549v-.61h1.376v4.654h-1.376v-.609c-.139.406-.683.692-1.385.692-.656 0-1.21-.231-1.653-.692-.434-.471-.655-1.044-.655-1.718 0-.674.221-1.246.655-1.708.443-.471.997-.702 1.653-.702.702 0 1.247.286 1.385.693zM56.264 244.093a1.13 1.13 0 0 0 .342-.831c0-.323-.111-.6-.342-.822a1.134 1.134 0 0 0-.84-.341c-.342 0-.628.11-.868.341-.23.222-.35.499-.35.822 0 .323.12.6.35.831.24.222.526.332.868.332.332 0 .61-.11.84-.332zm-3.352 3.277v-6.436h1.376v.61c.138-.407.683-.693 1.385-.693.655 0 1.21.231 1.643.702.443.462.665 1.034.665 1.708 0 .674-.222 1.247-.665 1.718-.434.461-.988.692-1.643.692-.702 0-1.247-.286-1.385-.692v2.391h-1.376zM58.495 245.59v-6.435h1.376v2.345c.185-.406.684-.665 1.302-.665 1.099 0 1.727.72 1.727 1.93v2.825h-1.376v-2.659c0-.545-.286-.877-.794-.877s-.859.378-.859.923v2.613h-1.376zM64.921 245.675l-1.948-4.737h1.431l1.237 3.103 1.256-3.103h1.431l-2.742 6.445h-1.413l.748-1.708z",
    fill: "#0B0826"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 157.406,
    y1: 68.351,
    x2: 157.406,
    y2: 78.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 157.403,
    y1: 186.867,
    x2: 157.403,
    y2: 196.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 126.122,
    y: 19.835,
    width: 199.393,
    height: 110.144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.708,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.708
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.354
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627 0 0 0 0 0.976471 0 0 0 0 0.988235 0 0 0 0.69575 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 126.119,
    y: 138.35,
    width: 199.393,
    height: 110.144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.708,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.708
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.354
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627 0 0 0 0 0.976471 0 0 0 0 0.988235 0 0 0 0.69575 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIllustration);
export default __webpack_public_path__ + "static/media/dashboard_illustration.5bd6246b.svg";
export { ForwardRef as ReactComponent };